import React, {useState} from "react";
import { Button, Control, Field, Input } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {createSetDataFreshAction} from "../../../../actions/dataActions";
import {useDispatch} from "react-redux";
import {ToastContainer, toast} from "react-toastify";


export default function VehicleMakeRow({makeData, index, onUpdate, dataFresh}){
    const dispatch = useDispatch();
    const [make, setMake] = useState(makeData);
    const [editable, setEditable] = useState(false);

    const onEdit = e => {
        e.stopPropagation();
        setEditable(!editable);
    };

    const onChange = (e) => {
        let newVehicleMake = {...make};
        newVehicleMake[e.target.name] = e.target.value || null;
        setMake(newVehicleMake);
        onUpdate(index, newVehicleMake);
    }

    const submitUpdate = (e) => {
        e.stopPropagation();
        const conf = {
            method: "put",
            data: make,
            url: "api/vehiclemake/"+make.id
        }
        axios(conf).then(res => {
           setEditable(false);
           dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    }

    const onDelete = () => {
        const conf = {
            method: "delete",
            url: "api/vehiclemake/"+make.id
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            if(err){
                toast.error("There was an error", {position: "top-right"});
            }
        })
    }

    return (
        <tr>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                          type={"text"}
                          name={"name"}
                          value={make.name}
                          disabled={!editable}
                          onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                      <Control>
                          <Button color="success" onClick={submitUpdate}>
                              Save
                          </Button>
                      </Control>
                    ) : (
                      <Control>
                          <Button onClick={onEdit}>Edit</Button>
                      </Control>
                    )}

                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                          type={"text"}
                          name={"maintenance_cost_per_mile"}
                          value={make.maintenance_cost_per_mile}
                          disabled={!editable}
                          onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                      <Control>
                          <Button color="success" onClick={submitUpdate}>
                              Save
                          </Button>
                      </Control>
                    ) : (
                      <Control>
                          <Button onClick={onEdit}>Edit</Button>
                      </Control>
                    )}

                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                          type={"text"}
                          name={"additional_depreciation_per_mile"}
                          value={make.additional_depreciation_per_mile}
                          disabled={!editable}
                          onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                      <Control>
                          <Button color="success" onClick={submitUpdate}>
                              Save
                          </Button>
                      </Control>
                    ) : (
                      <Control>
                          <Button onClick={onEdit}>Edit</Button>
                      </Control>
                    )}

                </Field>
            </td>
            <td>
                <Button
                  color={"danger"}
                  onClick={onDelete}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    );

}